import { isValidElement } from 'react'
import { takeEvery, put } from '@redux-saga/core/effects'
import { generateReactNodeMessage } from './helpers'
import { showToastAction } from './actions'
import { Log } from '../../utils'

function* showToastWorker({
  payload,
}: ReturnType<typeof showToastAction['request']>) {
  try {
    const { message } = payload

    if (Array.isArray(message))
      yield put(
        showToastAction.success({
          ...payload,
          id: Date.now(),
          message: generateReactNodeMessage(message as any),
        }),
      )
    else if (typeof message === 'string' || isValidElement(message))
      yield put(
        showToastAction.success({
          ...payload,
          id: Date.now(),
        }),
      )
    else
      yield put(
        showToastAction.success({
          ...payload,
          id: Date.now(),
          message: JSON.stringify(message),
        }),
      )
  } catch (e) {
    Log.ruddy('showToastWorker => e', e)

    yield put(
      showToastAction.success({
        ...payload,
        message: 'Unhandled toast message',
        id: Date.now(),
      }),
    )
  }
}

export function* toastsSaga() {
  yield takeEvery(showToastAction.request, showToastWorker)
}
